// extracted by mini-css-extract-plugin
export default {"cardContent":"PanelMembersContent_cardContent__3c1Cu","card":"PanelMembersContent_card__ElF8a"};